import { render } from "./channel-join-row.vue?vue&type=template&id=f487a386&lang=pug"
import script from "./channel-join-row.vue?vue&type=script&lang=js"
export * from "./channel-join-row.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__